import './style/index.less';
import AccountBackButton from './AccountBackButton';

export default AccountBackButton;
